import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonPopupModule } from '../popup/popup.module';
import { CommonDialogModule } from '../blocks/dialog/common-dialog.module';
import { CommonDialogFactoryComponent } from './components/dialog-factory.component';

@NgModule({
	imports: [
		CommonModule,
		CommonPopupModule,
		CommonDialogModule,
	],
	exports: [
		CommonDialogModule,
	],
	providers: [],
	declarations: [
		CommonDialogFactoryComponent,
	],
	entryComponents: [
		CommonDialogFactoryComponent,
	],
})
export class CommonDialogFactoryModule {}
